/**
 * This placeholder will get replaced by the `OrgApiUrlInterceptor`
 * with the currently active org's ID when the HTTP request is being made.
 */
export const ORG_API_URL_PARAM = '{orgId}';
/**
 * This placeholder will get replaced by the `OrgApiUrlInterceptor`
 * with the currently active org space's ID when the HTTP request is being made.
 */
export const ORG_SPACE_API_URL_PARAM = '{orgSpaceId}';
/**
 * This placeholder will get replaced by the `OrgApiUrlInterceptor`
 * with the currently active user's ID when the HTTP request is being made.
 */
export const ACTIVE_USER_ID_API_URL_PARAM = '{activeUserId}';
